import {API} from "../../Services";
import {AxiosCache} from "../../Services/AxiosCache/AxiosCache";

export async function RootCatApi(merchantId) {
    return API.get(`/shop/${merchantId}/product_category/?parent__isnull=true`);
}


export async function LevelCatApi(merchantId, Levelid) {
    let url = `/shop/${merchantId}/product_category_public/?parent__uid=${Levelid}`
    let config = {}
    return await AxiosCache({url, config, time: 1})
}

export async function productSearchApi(merchantId, search = null, page = 1, sort = null, startPrice = null, endPrice = null, available = null) {
    let token = localStorage.getItem('token');
    return API.get(`/shop/${merchantId}/product-public/`,
        {
            params: {
                search: search,
                page: page,
                sort: sort,
                is_available: available?available:null
            }
        }
    );
}
